import fetchClient, { ApiResponse } from '@/api/api-client'
import { UpdateUserPayload } from '@/api/auth/mutations/useUpdateUser'
import { CognitoUser, LoggedUser } from '@/api/auth/types/LoggedUser'

export async function listUsers(params: string, limit?: number, next?: string) {
  try {
    const payload = {
      params,
      limit,
      pageToken: next,
    }
    const res = await fetchClient.post<ApiResponse<{ users: CognitoUser[] }>>('/users', payload)

    return res.data.data
  } catch (err) {
    throw err
  }
}

export async function searchUserByPhoneOrTracking(searchFields: { trackingNumberInTurkey?: string; phoneNumber?: string }) {
  const res = await fetchClient.post<ApiResponse<CognitoUser>>('/users/search', searchFields)
  return res.data.data
}
// export async function listUsersPaginate(params, limit, next) {
//   try {
//     const payload = {
//       params,
//       limit,
//       pageToken: next,
//     }
//     // console.log(payload);
//     const res = await fetchClient.post(`/users/withpaginate`, payload)
//     //const res = await axios.post(`${BASEURL}/users/withpaginate`, payload);
//     return res.data
//   } catch (err) {
//     throw err
//   }
// }

export async function getUser(userId: string) {
  try {
    const res = await fetchClient.get<ApiResponse<CognitoUser>>(`/users/${userId}`)
    return res.data.data
  } catch (err) {
    throw err
  }
}

// export async function getAllUsers(params) {
//   try {
//     const res = await fetchClient.get(`/users/`)
//     //const res = await axios.get(`${BASEURL}/users/`)
//     return res.data.data
//   } catch (err) {
//     throw err
//   }
// }

export async function getCurrentUser() {
  try {
    const res = await fetchClient.get<ApiResponse<Omit<LoggedUser, 'permissions'>>>(`/users/currentUser`)
    //const res = await axios.get(`${BASEURL}/users/currentUser`, config)
    return res.data.data
  } catch (_err) {
    // console.log("getCurrentUser - err", err)
  }
}

export async function updateUser(params: UpdateUserPayload) {
  try {
    const res = await fetchClient.post(`/users/update`, params)
    //const res = await axios.post(`${BASEURL}/users/update`, payload)
    return res.data.data
  } catch (err) {
    throw err
  }
}

export async function deleteUser(username: string) {
  try {
    const res = await fetchClient.delete(`/users/${username}`)
    return res.data.data
  } catch (err) {
    throw err
  }
}

export async function confirmUser(username: string) {
  try {
    const res = await fetchClient.post(`/auth/admin-confirm-user`, { username })
    return res.data.data
  } catch (err) {
    throw err
  }
}

export async function currentAuthenticatedUser() {
  try {
    const token = JSON.parse(localStorage.getItem('cognito-tokens') || '{}')
    return Object.keys(token).length > 0 && (await getCurrentUser())
  } catch (_err) {
    // console.log("currentAuthenticatedUser - err", err)
  }
}
